import { render, staticRenderFns } from "./eduMineList.vue?vue&type=template&id=8ea7e5b4&scoped=true"
import script from "./eduMineList.vue?vue&type=script&lang=js"
export * from "./eduMineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea7e5b4",
  null
  
)

export default component.exports